import React from 'react'

const Footer = () => {
  return (
    <div className='text-white font-roboto text-center mb-3 hover:!text-orange-400 transition duration-500'>
        Copyright © Hashmeet S. | Made with 💖, 🍵, 🎧, 💤 in Toronto
    </div>
  )
}

export default Footer